import React, {useState} from "react";

const ModalInfo = ({icon, content}) => {
    const [isHovered, setIsHovered] = useState(false);

    const handleMouseEnter = () => {
        setIsHovered(true);
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };

    return (
        <div className="relative">
            <div
                className="cursor-pointer"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            >
                <p>{icon}</p>

                {
                    isHovered && (
                        <div
                            className="absolute w-80 z-50 bg-black opacity-90 p-4 text-sm text-justify rounded shadow top-6 right-0">
                            <p className="text-white">{content}</p>
                        </div>
                    )
                }
            </ div>
        </div>
    );
}

export default ModalInfo;